export default {"src":"/_next/static/image/public/images/ic_delivery_truck.23b718e38d33038fb2607daf4fc75d6d.svg","height":16,"width":27};